import { publicAxios } from "@ac-expo/api";
import { ResolveEmailResponse } from "@ac-expo/api-types";
import { AuthErrorResult, parseAuthError } from "@ac-expo/utils";
import { authClient } from "@web-app/src/services/auth-client";
import { isAxiosError } from "axios";

export type SignInCredentials = {
  emailOrConnectId: string;
  password: string;
};

export type CredentialsSignInResult =
  | { ok: true }
  | ({ ok: false } & AuthErrorResult);

const refusal = (
  rawMessage: string | null | undefined
): CredentialsSignInResult => ({
  ok: false,
  ...parseAuthError(rawMessage ?? "Une erreur est survenue"),
});

/**
 * Password sign-in as the login modal and the counter handover both do it: the
 * identifier or email is resolved to the account email, then the credentials
 * are checked. The browser session becomes that account's on success.
 */
export const signInWithCredentials = async ({
  emailOrConnectId,
  password,
}: SignInCredentials): Promise<CredentialsSignInResult> => {
  try {
    const { data: resolved } = await publicAxios.post<ResolveEmailResponse>(
      "/auth/resolve-email",
      { emailOrConnectId }
    );

    const signIn = await authClient.signIn.email({
      email: resolved.email,
      password,
    });

    if (signIn.error) return refusal(signIn.error.message);

    return { ok: true };
  } catch (error) {
    return refusal(isAxiosError(error) ? error.response?.data?.message : null);
  }
};
